var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.833,
    height: 441.61,
    viewBox: "0 0 304.833 441.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(-118.074 -1414.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M387.609,1767.532a.875.875,0,0,0,1.195-.32l1.88-3.256a.874.874,0,1,0-1.514-.875l-1.88,3.256A.873.873,0,0,0,387.609,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M376.8,1767.532a.875.875,0,0,0,1.2-.32l7.286-12.618a.875.875,0,1,0-1.514-.876l-7.286,12.619A.874.874,0,0,0,376.8,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M365.987,1767.532a.874.874,0,0,0,1.194-.32l12.691-21.982a.873.873,0,0,0-.319-1.195.863.863,0,0,0-.436-.118.876.876,0,0,0-.759.438l-12.691,21.982A.874.874,0,0,0,365.987,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M355.175,1767.532a.874.874,0,0,0,1.194-.32l18.1-31.345a.874.874,0,1,0-1.514-.875l-18.1,31.345A.874.874,0,0,0,355.175,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M344.363,1767.532a.875.875,0,0,0,1.2-.32l23.5-40.708a.874.874,0,1,0-1.514-.875l-23.5,40.708A.873.873,0,0,0,344.363,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M333.551,1767.532a.875.875,0,0,0,1.2-.32l28.909-50.071a.874.874,0,1,0-1.514-.875l-28.909,50.071A.873.873,0,0,0,333.551,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M322.741,1767.532a.874.874,0,0,0,1.194-.32l34.315-59.434a.874.874,0,1,0-1.514-.875l-34.315,59.434A.874.874,0,0,0,322.741,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M311.929,1767.532a.874.874,0,0,0,1.194-.32l39.72-68.8a.874.874,0,1,0-1.514-.875l-39.72,68.8A.874.874,0,0,0,311.929,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M301.118,1767.532a.875.875,0,0,0,1.195-.32l45.125-78.16a.874.874,0,1,0-1.514-.875l-45.125,78.16A.873.873,0,0,0,301.118,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M290.306,1767.532a.875.875,0,0,0,1.2-.32l50.531-87.523a.874.874,0,0,0-.32-1.195.863.863,0,0,0-.436-.118.874.874,0,0,0-.758.438l-50.531,87.523A.874.874,0,0,0,290.306,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M279.495,1767.532a.874.874,0,0,0,1.194-.32l55.937-96.886a.874.874,0,1,0-1.514-.875l-55.937,96.886A.874.874,0,0,0,279.495,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M268.683,1767.532a.874.874,0,0,0,1.194-.32l61.344-106.249a.874.874,0,1,0-1.514-.875l-61.344,106.249A.874.874,0,0,0,268.683,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M257.872,1767.532a.875.875,0,0,0,1.195-.32L325.815,1651.6a.875.875,0,0,0-1.515-.875l-66.747,115.612A.873.873,0,0,0,257.872,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M247.06,1767.532a.875.875,0,0,0,1.2-.32l72.154-124.974a.875.875,0,1,0-1.514-.876l-72.154,124.975A.874.874,0,0,0,247.06,1767.532Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M236.25,1767.532a.874.874,0,0,0,1.194-.32L315,1632.875a.874.874,0,0,0-.32-1.195.863.863,0,0,0-.436-.118.873.873,0,0,0-.758.438l-77.56,134.337A.874.874,0,0,0,236.25,1767.532Z",
    fill: "#a0bddf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M422.091,1618.1a.437.437,0,1,0,.757-.438l-.8-1.393a.437.437,0,0,0-.757.438Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M419.779,1622.108a.437.437,0,1,0,.757-.438l-3.116-5.4a.437.437,0,0,0-.378-.218.443.443,0,0,0-.219.058.438.438,0,0,0-.16.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M417.467,1626.113a.437.437,0,1,0,.757-.438l-5.428-9.4a.437.437,0,0,0-.379-.218.442.442,0,0,0-.218.058.437.437,0,0,0-.16.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M415.155,1630.118a.437.437,0,0,0,.757-.438l-7.741-13.408a.437.437,0,0,0-.379-.218.43.43,0,0,0-.218.059.437.437,0,0,0-.161.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M412.843,1634.122a.437.437,0,1,0,.757-.437l-10.054-17.413a.434.434,0,0,0-.378-.218.428.428,0,0,0-.218.059.437.437,0,0,0-.161.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M410.53,1638.127a.437.437,0,0,0,.757-.437l-12.365-21.418a.437.437,0,0,0-.757.438Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M408.218,1642.133a.437.437,0,0,0,.757-.438L394.3,1616.272a.437.437,0,0,0-.757.438Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M405.9,1646.138a.438.438,0,0,0,.758-.438l-16.99-29.428a.437.437,0,0,0-.379-.218.43.43,0,0,0-.218.059.436.436,0,0,0-.16.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M403.593,1650.142a.437.437,0,1,0,.757-.437l-19.3-33.433a.437.437,0,0,0-.379-.218.43.43,0,0,0-.218.059.437.437,0,0,0-.161.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M401.281,1654.147a.437.437,0,1,0,.757-.437l-21.614-37.438a.435.435,0,0,0-.378-.218.428.428,0,0,0-.218.059.437.437,0,0,0-.161.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M398.969,1658.153a.437.437,0,0,0,.757-.438L375.8,1616.272a.437.437,0,0,0-.757.438Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M396.657,1662.157a.437.437,0,1,0,.757-.437l-26.239-45.448a.437.437,0,0,0-.757.438Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M394.345,1666.162a.437.437,0,1,0,.757-.437l-28.551-49.453a.437.437,0,0,0-.379-.218.43.43,0,0,0-.218.059.436.436,0,0,0-.16.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M392.032,1670.167a.437.437,0,0,0,.757-.438l-30.864-53.457a.435.435,0,0,0-.378-.218.428.428,0,0,0-.218.059.437.437,0,0,0-.161.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M389.72,1674.172a.437.437,0,0,0,.757-.438L357.3,1616.272a.437.437,0,0,0-.757.438Z",
    fill: "#a0bddf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M283.4,1459.479a.434.434,0,0,0,.6-.16l.621-1.075a.437.437,0,1,0-.757-.437l-.621,1.075A.438.438,0,0,0,283.4,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M279.835,1459.479a.433.433,0,0,0,.6-.16l2.4-4.164a.437.437,0,1,0-.757-.438l-2.4,4.165A.437.437,0,0,0,279.835,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M276.266,1459.479a.434.434,0,0,0,.6-.16l4.189-7.255a.437.437,0,0,0-.757-.438l-4.189,7.256A.438.438,0,0,0,276.266,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M272.7,1459.479a.434.434,0,0,0,.6-.16l5.973-10.345a.437.437,0,1,0-.757-.438l-5.973,10.346A.437.437,0,0,0,272.7,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M269.13,1459.479a.434.434,0,0,0,.6-.16l7.757-13.435a.437.437,0,1,0-.757-.437l-7.757,13.435A.436.436,0,0,0,269.13,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M265.562,1459.479a.435.435,0,0,0,.6-.16l9.541-16.526a.437.437,0,1,0-.757-.437l-9.541,16.526A.436.436,0,0,0,265.562,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M261.994,1459.479a.433.433,0,0,0,.6-.16l11.326-19.615a.437.437,0,0,0-.161-.6.429.429,0,0,0-.218-.06.438.438,0,0,0-.378.219l-11.326,19.616A.437.437,0,0,0,261.994,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M258.426,1459.479a.433.433,0,0,0,.6-.16l13.11-22.7a.437.437,0,1,0-.757-.438l-13.11,22.706A.437.437,0,0,0,258.426,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M254.857,1459.479a.434.434,0,0,0,.6-.16l14.894-25.8a.437.437,0,0,0-.161-.6.428.428,0,0,0-.218-.059.433.433,0,0,0-.378.219l-14.894,25.8A.437.437,0,0,0,254.857,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M251.289,1459.479a.434.434,0,0,0,.6-.16l16.678-28.886a.437.437,0,0,0-.161-.6.434.434,0,0,0-.6.16l-16.678,28.886A.436.436,0,0,0,251.289,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M247.721,1459.479a.435.435,0,0,0,.6-.16l18.461-31.976a.436.436,0,0,0-.16-.6.431.431,0,0,0-.218-.059.437.437,0,0,0-.379.218l-18.461,31.977A.436.436,0,0,0,247.721,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M244.153,1459.479a.435.435,0,0,0,.6-.16l20.245-35.066a.437.437,0,1,0-.757-.438l-20.245,35.067A.436.436,0,0,0,244.153,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M240.585,1459.479a.433.433,0,0,0,.6-.16l22.03-38.156a.437.437,0,1,0-.757-.438l-22.03,38.157A.437.437,0,0,0,240.585,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M237.016,1459.479a.434.434,0,0,0,.6-.16l23.813-41.246a.437.437,0,0,0-.757-.438l-23.813,41.247A.438.438,0,0,0,237.016,1459.479Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M233.448,1459.479a.435.435,0,0,0,.6-.16l25.6-44.336a.437.437,0,0,0-.16-.6.443.443,0,0,0-.218-.059.438.438,0,0,0-.379.219l-25.6,44.337A.437.437,0,0,0,233.448,1459.479Z",
    fill: "#a0bddf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M278.829,1648.8a.455.455,0,0,0,.757,0l7.839-13.579a.432.432,0,0,0,0-.437.437.437,0,0,0-.378-.219h-15.68a.437.437,0,0,0-.378.219.432.432,0,0,0,0,.437Zm7.46-13.36-7.081,12.266-7.082-12.266Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M304.94,1855.734a.455.455,0,0,0,.757,0l16.117-27.917a.438.438,0,0,0-.378-.656H289.2a.438.438,0,0,0-.379.656Zm15.739-27.7-15.36,26.6-15.361-26.6Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M118.948,1775.46h59.467a.875.875,0,0,0,.757-1.312l-29.733-51.5a.875.875,0,0,0-1.514,0l-29.734,51.5a.875.875,0,0,0,.757,1.312Zm29.734-50.625,28.218,48.876H120.464Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M202.081,1615.959a.875.875,0,0,0,1.515,0l7.84-13.579a.875.875,0,0,0-.757-1.312H195a.875.875,0,0,0-.757,1.312Zm7.083-13.142-6.326,10.954-6.323-10.954Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M182.863,1746.163a.455.455,0,0,0,.757,0l11.156-19.323a.438.438,0,0,0-.379-.656H172.085a.437.437,0,0,0-.378.219.433.433,0,0,0,0,.437Zm10.777-19.1-10.4,18.011-10.4-18.011Z",
    fill: "#a0bddf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M166.322,1501.69a.455.455,0,0,0,.757,0l45.263-78.4a.438.438,0,0,0-.379-.657H121.436a.438.438,0,0,0-.378.657Zm44.884-78.181L166.7,1500.6l-44.507-77.087Z",
    fill: "#a0bddf"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.cb689cf9aabd403c5976210e97fc7fd7.svg";
export { ForwardRef as ReactComponent };